import { render, staticRenderFns } from "./Biz.vue?vue&type=template&id=72555aa0&scoped=true&lang=html&"
import script from "./Biz.vue?vue&type=script&lang=ts&"
export * from "./Biz.vue?vue&type=script&lang=ts&"
import style0 from "./Biz.vue?vue&type=style&index=0&id=72555aa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72555aa0",
  null
  
)

export default component.exports